import { array, boolean, InferType, number, object, string } from "yup";
import { TWritingType } from "./orders/order";
import { ThematicSchema } from "./Thematic";

export const ImageContentSchema = object({
    id: number().required(),
    url: string().nullable(),
    position: string().nullable(),
    largeImageUrl: string().required("error.imageContent.largeImageUrl.required"),
    previewUrl: string().required("error.imageContent.previewUrl.required"),
    tags: string(),
});

export const ContentSchema = object({
    id: number().required(),
    active: boolean().required("error.content.active.required"),
    thematic: ThematicSchema.nullable().default(null),
    wordCount: number().nullable(),
    writingType: string<TWritingType>().required("error.order.writingType.required"),
    title: string().nullable(),
    metaTitle: string()
        .max(
            parseInt(process.env.REACT_APP_MAX_NUMBER_OF_CHAR_IN_META_TITLE || "0", 10),
            "error.content.metaTitle.max"
        )
        .nullable(),
    metaDescription: string()
        .max(
            parseInt(process.env.REACT_APP_MAX_NUMBER_OF_CHAR_IN_META_DESC || "0", 10),
            "error.content.metaDescription.max"
        )
        .nullable(),
    category: string().nullable(),
    keywords: array().of(string()).nullable(),
    text: string().nullable(),
    images: array().of(ImageContentSchema).nullable(),
});

export const UpsertContentDTOSchema = ContentSchema.omit([
    "id",
    "active",
    "thematic",
    "writingType",
    "images",
]).concat(
    object({
        id: number(),
        orderId: number(),
        thematicId: number(),
        writingType: string<TWritingType>(),
        hasReviewed: boolean().nullable(),
        rate: number().nullable(),
    })
);

export const UpsertLibraryContentDTOSchema = ContentSchema.omit([
    "id",
    "active",
    "thematic",
]).concat(
    object({
        id: number(),
        thematicId: number(),
    })
);

export type UpsertContentDTO = InferType<typeof UpsertContentDTOSchema>;
export type UpsertLibraryContentDTO = InferType<typeof UpsertLibraryContentDTOSchema>;
export type ImageContent = InferType<typeof ImageContentSchema>;
export type Content = InferType<typeof ContentSchema>;
